import { Ajax } from '@mabinso-registry/module-commons';

export default Ajax;
